<template>
    <div class="leftPage">
        <div class="search">
            <el-input
                type="text"
                style="width:250px"
                :placeholder="$t('public.please_enter')"
                v-model="filterText"
                clearable
            ></el-input>
            <el-button type="primary" icon="el-icon-search" class="btnClass" @click="searchTree"></el-button>
        </div>
        <div class="tree">
            <trees :treedata="treeData" ref="tree" @changeNode="changeNode"></trees>
        </div>
    </div>
</template>

<script>
import bus from '@/utils/bus.js'
export default {
    name: "tree",
    watch: {
    },
    data() {
        return {
            filterText: "",
            treeData: []
        }
    },
    created() {
        // 这里使用深拷贝一下
        this.treeData = JSON.parse(JSON.stringify(this.$store.getters.SchemaTree))
    },
    mounted() {
    },
    methods: {
        searchTree() {
            this.$refs.tree.$refs.tree.filter(this.filterText);
        },
        changeNode({ label, row, children }) {
            bus.$emit('nodeClickFn', label)
        }
    }
}
</script>

<style lang="scss" scoped>
.leftPage {
    width: 300px;
    height: 100%;
    margin-right: 15px;
    border-right: 1px solid $borderColor3;
    box-sizing: border-box;
}
.search {
    width: 100%;
    height: 50px;
    padding: 10px 3px;
    border-bottom: 1px solid $borderColor3;
    box-sizing: border-box;
    display: flex;
    align-items: center;
}
.btnClass {
    min-width: 0;
    width: 40px;
    margin-left: 0px;
    margin-top: 0px;
}
.tree {
    height: calc(100% - 50px);
    background-color: antiquewhite;
    overflow: auto;
}
</style>
